// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const unfezant: PokeData = {
  "id": 521,
  "name": "unfezant",
  "height": 12,
  "weight": 290,
  "base_experience": 220,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "gust",
    "leer",
    "growl",
    "quick-attack",
    "sky-attack",
    "detect",
    "swagger",
    "facade",
    "taunt",
    "feather-dance",
    "air-cutter",
    "roost",
    "tailwind",
    "air-slash"
  ],
  "moves": [
    "gust",
    "leer",
    "growl",
    "quick-attack",
    "sky-attack",
    "roost",
    "tailwind",
    "air-slash",
    "protect",
    "hurricane",
    "headbutt",
    "body-slam",
    "aerial-ace"
  ],
  "evolution_chain": {
    "id": 266,
    "item": null,
    "species": [
      {
        "name": "pidove",
        "order": 520,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "tranquill",
        "order": 521,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 519,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "unfezant",
        "order": 522,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 520,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 132,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
